import { createContext } from 'react';

import { OpenDialogOptions } from './types';

export type TagFormContextProps = {
  onCreateTag: (options?: OpenDialogOptions) => void;
  onEditTag: (options?: Omit<OpenDialogOptions, 'navigateOnCreate'>) => void;
};

export const TagFormContext = createContext<TagFormContextProps>({
  onCreateTag: () => {},
  onEditTag: () => {},
});
